import anim from '../../assets/loading.svg';

const Loading = () => {
    return <div>
        <img src={anim} alt='loading' width={50}/>
    </div>
}

export default Loading;